/**
 * Blog Section API service
 */

import { fetchStrapi } from './strapi';

/**
 * Blog Section data structure
 */
export interface BlogSection {
  badgeText: string;
  heading: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  pageTitle: string;
  pageSubheading: string;
  noArticlesText: string;
  readMoreText: string;
  backToBlogText: string;
  notFoundText: string;
  relatedArticlesPrefix: string;
}

/**
 * Fetch blog section data from Strapi
 */
export async function fetchBlogSection(): Promise<BlogSection | null> {
  try {
    const response = await fetchStrapi<any>('/blog-section');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      badgeText: data.badgeText || '',
      heading: data.ueberschrift || '',
      description: data.beschreibung || '',
      buttonText: data.buttonText || '',
      buttonLink: data.buttonLink || '',
      pageTitle: data.seitenTitel || 'Blog',
      pageSubheading: data.seitenUnterueberschrift || '',
      noArticlesText: data.keineArtikelText || 'Keine Artikel in dieser Kategorie gefunden.',
      readMoreText: data.weiterlesenText || 'Weiterlesen',
      backToBlogText: data.zurueckZumBlogText || 'Zurück zum Blog',
      notFoundText: data.nichtGefundenText || 'Artikel nicht gefunden',
      relatedArticlesPrefix: data.weitereArtikelPrefix || 'Weitere Artikel zum Thema',
    };
  } catch (error) {
    console.error('Error fetching blog section from Strapi:', error);
    return null;
  }
}


